import { Component } from '@angular/core';
import { BlogNewsComponent, GoogleTagManagerService } from '@prekog/common-ui';

@Component({
    selector: 'app-smarty',
    templateUrl: './smarty.component.html',
    styleUrls: ['./smarty.component.scss'],
    standalone: true,
    imports: [BlogNewsComponent]
})
export class SmartyComponent {
    bookAppointmentsUrl = 'https://medicall.cc/idopontfoglalas/regenero/index';

    nameOfLink = 'IDŐPONTFOGLALÁS LINK MEGTEKINTÉSE';

    constructor(private _googleTagManagerService: GoogleTagManagerService) { }

    settingUpLinkToGoogleAnalytics() {
        this._googleTagManagerService.pushLinkIntoDataLayer(this.nameOfLink, this.bookAppointmentsUrl);
    }
}
